import { useEffect } from 'react';
import { enforceJalaliDatesInDom } from '../utils/dateUtils';

export default function PersianDateGuard() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;

    const root = document.getElementById('root') || document.body;
    if (!root) return undefined;

    let frame = null;
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        enforceJalaliDatesInDom(root);
      });
    };

    schedule();

    const observer = new MutationObserver(() => {
      schedule();
    });

    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    window.addEventListener('load', schedule);
    window.addEventListener('popstate', schedule);

    return () => {
      observer.disconnect();
      window.removeEventListener('load', schedule);
      window.removeEventListener('popstate', schedule);
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return null;
}
